export default __webpack_public_path__ + "static/media/total-icon.d0339783.svg";